var pdfUtils = {
    /*
      *  This function removes unwanted spaces
      */
    getElementHtmlTrim : function getElementHtmlTrim(ele) {
        var value = ele.length ? ele.html().trim().replace(/\s+/g, ' ') : '';
        return value;
	 }
};

export default pdfUtils;
